module.exports = __webpack_public_path__ + "static/logo-white-dc9631ecaae43c239c0699beb755adcd.svg";